module.exports = __webpack_public_path__ + "img/SMT_26_Ms_Yeo_Li_Li.c055c9a7.jpg";